import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function Footer() {
  const {
    t,
    getPath
  } = useLanguage();
  return <footer className="w-full py-10 sm:py-12 border-t" style={{
    backgroundColor: 'var(--bg-secondary)',
    borderColor: 'var(--border)'
  }} data-id="element-202">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-203">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-204">
          <span className="text-lg sm:text-xl font-semibold tracking-tight" style={{
          color: 'var(--text-primary)'
        }} data-id="element-205">
            IT Monsters
          </span>

          <a href={getPath('privacy')} className="text-xs sm:text-sm hover:underline" style={{
          color: 'var(--text-secondary)'
        }} data-id="element-206">
            {t('nav.privacy')}
          </a>

          <div className="text-xs sm:text-sm text-center" style={{
          color: 'var(--text-muted)'
        }} data-id="element-207">
            © IT Monsters. {t('footer.rights')}
          </div>
        </div>
      </div>
    </footer>;
}